function toggle(menuElements: any) {
  // Destructuring
  const { header, menu, menuButton } = menuElements;

  // Check menu state
  const isOpen = menu.classList.contains('header__nav--open');

  // Toggle menu
  if (isOpen) {
    menu.classList.remove('header__nav--open');
    menuButton.classList.remove('header__nav-trigger--open');
    header.classList.remove('header--open');
  } else {
    menu.classList.add('header__nav--open');
    menuButton.classList.add('header__nav-trigger--open');
    header.classList.add('header--open');
  }
}

function MobileMenu() {
  // Get all required elements in object
  const menuElements = {
    header: document.querySelector('.header'),
    menu: document.querySelector('nav'),
    menuButton: document.querySelector('.header__nav-trigger'),
  };

  // On menu button click toggle menu
  menuElements.menuButton.addEventListener('click', () => toggle(menuElements), false);
}

export default MobileMenu;
